import axios from 'axios'

/**
 * 优惠类型
 * @typedef {Object} CouponType
 * @property {number} fee_pct 原价百分比
 * @property {number} fee_abs 减免金额(分)
 * @property {number} exp_mon 赠送时间(月)
 * @property {number} invalid 无效优惠码
 */

/**
 * @type {CouponType}
 */

export const CouponType = {
	fee_pct: 0,
	fee_abs: 1,
	exp_mon: 2,
	invalid: 3,
}

export const getQueryString = name => {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
	var r = window.location.search.substr(1).match(reg)
	if (r != null) return unescape(r[2])
	return null
}

export const getCouponInfo = async (coupon_code, isIrresistible) => {
	return axios({
		url: '/d/ajax/getCoupon',
		method: 'post',
		data: `coupon_code=${coupon_code}`,
	})
		.then(res => {
			const data = res.data || {}
			data.fee_abs = Number(data.fee_abs) || 0
			data.fee_pct = Number(data.fee_pct) || 0
			data.exp_mon = Number(data.exp_mon) || 0
			data.coupon_type = Number(data.coupon_type)
			data.expire_time = Number(data.coupon_expire_time)
			const isCouponInvalid = data.coupon_type === CouponType.invalid

			data.lower_bound =
				data.coupon_type === CouponType.exp_mon
					? data.lower_bound
					: Number(data.lower_bound) / 100
			// 空优惠码的情况，暂时不做处理
			// (data.fee_abs === 0 && data.fee_pct === 0 && data.exp_mon === 0) || data.fee_pct === 100

			// 有优惠码 但是优惠码无效
			if (isCouponInvalid) {
				return { coupon_code, isCouponInvalid }
			} else {
				// 有优惠码且优惠有效
				return {
					...data,
					coupon_code,
					isCouponInvalid,
					isIrresistible,
				}
			}
		})
		.catch(() => {
			// 有优惠码 但是优惠码无效
			return { coupon_code, isCouponInvalid: true }
		})
}

export const createPromotionCoupon = async () => {
	try {
		const res = await axios({
			url: '/d/ajax/createPromotionCoupon',
			method: 'post',
		})

		if (res && res.data && res.data.coupon_code) {
			return await getCouponInfo(res.data.coupon_code)
		} else {
			return {
				isCouponInvalid: true,
			}
		}
	} catch (err) {
		return {
			isCouponInvalid: true,
		}
	}
}

// 优惠码判断  1 无优惠码 2 有优惠码,优惠无效 3.无优惠码
export const getCouponCode = (() => {
	const coupon_code = getQueryString('coupon_code')
	const isIrresistible = getQueryString('irresistible')
	// 无优惠码
	if (!coupon_code) {
		return Promise.resolve({ isCouponInvalid: true })
	}
	return getCouponInfo(coupon_code, isIrresistible)
})()
